import ReadMore from './container';

export default ReadMore;



// WEBPACK FOOTER //
// ./app/src/components/ReadMore/index.jsx